module.exports = __webpack_public_path__ + "img/lock.aad845a7.svg";